import type { AdapterCodec, AdapterDrm, AdapterQuality } from '../../../data/playbackContext';
import { KalturaPlaybackContextType, KalturaStreamerType } from '../../enums';
import { createKalturaStringValue } from '../../factories';
import { processPlaybackContext } from '../../processing/playbackContext/playbackContext';
import { fetchAssetPlaybackContext } from '../../services/asset';

import { handlePlaybackContextErrors } from './handlePlaybackContextErrors';

export type FetchProgramPlaybackContextArgs = {
  adapterCodec: AdapterCodec;
  adapterDrm: AdapterDrm;
  adapterQuality: AdapterQuality;
  assetId: string;
  contextType: KalturaPlaybackContextType;
  streamerType: KalturaStreamerType;
};

export async function fetchProgramPlaybackContext({
  adapterCodec,
  adapterDrm,
  adapterQuality,
  assetId,
  contextType,
  streamerType,
}: FetchProgramPlaybackContextArgs) {
  const playbackContext = await fetchAssetPlaybackContext({
    assetId,
    assetType: 'epg',
    contextDataParams: {
      adapterData: {
        codec: createKalturaStringValue(adapterCodec),
        drm: createKalturaStringValue(adapterDrm),
        quality: createKalturaStringValue(adapterQuality),
      },
      context: contextType,
      streamerType,
      urlType: 'DIRECT',
    },
  });

  handlePlaybackContextErrors(playbackContext);

  return processPlaybackContext(playbackContext);
}
